import http from "./http.service";
import { getStorageItem } from "./storage.service";


export const getUserDetails = async () => {
    return http.get(`/manage-profile`);
};

export const updateUserProfile = async (payload: any) => {
    return http.put(`/manage-profile`, payload);
}

export const delteUserProfile = async () => {
    return http.delete(`/manage-profile`);
}

export const changePassword = async (payload: any) => {
    return http.put(`/change-password`, payload);
}

export const getUserID = () => {
    return getStorageItem('id');
}

export const isLoginUser = () => {
    return getStorageItem('token') ? true : false;
}
